import { useState } from "react";
import { AsciiSearch, SearchFilter } from "../components/AsciiSearch"
import { AsciiTable } from "../components/AsciiTable"

export function Ascii() {
  const [searchFilter, setSearchFilter] = useState<SearchFilter>({})
  return <div>
    <AsciiSearch onChange={setSearchFilter} />

    <AsciiTable filter={searchFilter} />
  </div>
}